module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (43).d6462e15.jpg";